import { Note } from "../../../../../Abpn.BoardCert.Web.Internal/Scripts/Common/Models/Note";

export class TrainingNote {
    constructor(physicianId: number, source: string, note: Note) {
        this.physicianId = physicianId;
        this.source = source;
        this.note = note;
    }
    physicianId: number;
    trainingNoteId: number;
    source: string;
    note: Note;
}